import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'contextualMenu.stylesOnMap.vehicle.title' }),
    subtitle: translate({ id: 'contextualMenu.stylesOnMap.vehicle.subTitle' }),
    show: translate({ id: 'contextualMenu.stylesOnMap.vehicle.show' }),
    reduce: translate({ id: 'contextualMenu.stylesOnMap.vehicle.reduce' }),
    hide: translate({ id: 'contextualMenu.stylesOnMap.vehicle.hide' }),
  }))

  return api
}
